import React, { useEffect, useState, useRef, useCallback } from 'react';
// import { gsap } from 'gsap';
import ThreeDodecahedron from './ThreeDodecahedron';
import './MathShapes.css';

const MathShapes = () => {
  const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0, z: 0 });
  const shapesRef = useRef(null);

  useEffect(() => {
    // Generate random values and set CSS variables for the shapes
    document.documentElement.style.setProperty('--random-1', Math.random());
    document.documentElement.style.setProperty('--random-2', Math.random());
    document.documentElement.style.setProperty('--random-3', Math.random());
    document.documentElement.style.setProperty('--random-4', Math.random());
    document.documentElement.style.setProperty('--random-5', Math.random());
    document.documentElement.style.setProperty('--random-6', Math.random());
    document.documentElement.style.setProperty('--random-7', Math.random());
    document.documentElement.style.setProperty('--random-8', Math.random());
    document.documentElement.style.setProperty('--random-9', Math.random());
    document.documentElement.style.setProperty('--random-10', Math.random());
  }, []);

  const handleScroll = useCallback(() => {
    const scrollY = window.scrollY;
    const skillsSection = document.getElementById('skills');
    
    if (skillsSection) {
      const sectionTop = skillsSection.offsetTop;
      const sectionBottom = sectionTop + skillsSection.offsetHeight;
      const viewportHeight = window.innerHeight;
      
      // Check if Skills section is visible in viewport
      const sectionVisible = scrollY >= sectionTop - viewportHeight && scrollY <= sectionBottom;
      
      if (sectionVisible) {
        // Calculate how much of the section is visible
        const sectionStart = sectionTop - viewportHeight;
        const sectionEnd = sectionBottom;
        const totalRange = sectionEnd - sectionStart;
        const progress = Math.max(0, Math.min(1, (scrollY - sectionStart) / totalRange));
        
        // Smooth movement from bottom to top
        const verticalPosition = (1 - progress) * 150 - 75; // From 75vh to -75vh
        
        setScrollPosition({
          x: 0,
          y: verticalPosition,
          z: 0,
        });
      }
    }
  }, []);

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <div className="math-shapes" ref={shapesRef}>
        <ThreeDodecahedron position={scrollPosition} />
        {/* <div className="shape shape1 pyramid"></div>
        <div className="shape shape2 dodecahedron"></div>
        <div className="shape shape3 icosahedron"></div>
        <div className="shape shape4 pentagonal-prism"></div>
        <div className="shape shape5 octahedron"></div> */}
    </div>
  );
};

export default MathShapes;
